import React from 'react';
import Footer from 'common/footer.jsx';
import Header from 'common/header.jsx';
import Topbar from 'common/topbar.jsx';

var App = React.createClass({
    render: function () {
        return (
            <div>
                <Topbar/>
                <Header className="header-b"/>
                {this.props.children}
                <Footer/>
            </div>
        )
    }
});

module.exports = App;



// WEBPACK FOOTER //
// ./pages/app.jsx